<div class="noauth-container">
    <h2>STOP!!</h2>
    <p class="msg-dis">You are trying to access protected content. Contact your admin for authorization!</p>
</div>